import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { 
    FindWithdrawalByIdAdminQueryQuery, 
    QueryFindWithdrawalByIdAdminArgs
} from "../../../../../schemaTypes";

export const findWithdrawalByIdAdminQuery = gql`
  query FindWithdrawalByIdAdminQuery(
    $id: String!
  ) {
    findWithdrawalByIdAdmin(
      id: $id
    ) {
       id
        transaction {
            id 
            amount 
            status
            wallet {
                id
                flAccountReference
                barterId
                balance
            }
            user {
                id
                admin{
                    id
                    merchantProfile {
                        companyName
                        businessName
                    }
                }
            }
            status
            currency
        }
        bankPreference{
          id
          bank {
            id 
            bank 
            bankCode
          }
          accountNo
        }
        createdAt
    }
  }
`;

export interface WithFindWithdrawalByIdAdmin {
    id: string;
    bankPreference: FindWithdrawalByIdAdminQueryQuery["findWithdrawalByIdAdmin"]["bankPreference"] | null;
    transaction: FindWithdrawalByIdAdminQueryQuery["findWithdrawalByIdAdmin"]["transaction"] | null;
    createdAt: string;
}

interface Props {
  variables: QueryFindWithdrawalByIdAdminArgs;
  children: (data: WithFindWithdrawalByIdAdmin) => React.ReactElement | null;
}

export const FindWithdrawalByIdAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    FindWithdrawalByIdAdminQueryQuery,
    QueryFindWithdrawalByIdAdminArgs
  >(findWithdrawalByIdAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const id = data?.findWithdrawalByIdAdmin.id || "";
  const bankPreference = data?.findWithdrawalByIdAdmin.bankPreference || null; 
  const createdAt = data?.findWithdrawalByIdAdmin.createdAt || "";
  const transaction = data?.findWithdrawalByIdAdmin.transaction || null;

  return children({
        id,
        bankPreference,
        transaction,
        createdAt
  });
};